/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import { satisfies } from "semver";

let threadId: string | undefined;

/**
 * Returns the current thread id formatted as a hexadecimal encoded string.
 *
 * On sytems older than 12.x without support for worker_threads, the thread id is always 00000000
 */
export let getThreadId = (): string => {
	return "00000000";
};

if (satisfies(process.version, ">=12")) {
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	const workers = require("worker_threads") as typeof import("worker_threads");

	getThreadId = () => {
		if (!threadId) {
			threadId = workers.threadId.toString(16).toUpperCase().padStart(8, "0");
		}

		return threadId;
	};
}

export function __testUncacheThreadId(): void {
	threadId = undefined;
}
